module.exports = "/assets/8e6e4e7d01569cec03abb663e3eb4790.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SX.png
// module id = 2958
// module chunks = 0